import { $, addAction, INIT } from '@situation/setdesign.util';
import Carousel from '../shared/slider/Carousel';
import NavSlider from '../shared/slider/NavSlider';
import SlideFilter from '../shared/slider/SlideFilter';

addAction(INIT, () => {
    const $carouselMain = $('.home-slider__main');
    const $carouselNav = $('.home-slider__nav');
    // eslint-disable-next-line no-new
    new SlideFilter($carouselMain, $carouselNav);

    if (!($carouselMain.length && $carouselNav.length)) {
        return;
    }

    // eslint-disable-next-line no-new
    new NavSlider($carouselNav);
    // eslint-disable-next-line no-new
    new Carousel($carouselMain);
});
